import * as React from "react";
import { Option, useFormApi, useFormState } from "informed";

import { Dropdown } from "../../../../forms/informedv2/Dropdown";
import { SubjectType } from "webportalclient";

interface EnterNewSubjectTypeProps {
    originalSubjectType: string;
    onNext: (newSubjectType: string) => void;
    subjectTypes: SubjectType[];
}

interface EnterNewSubjectTypeForm {
    correctedSubjectType: string;
}

export const EnterNewSubjectType = ({ originalSubjectType, onNext, subjectTypes }: EnterNewSubjectTypeProps): JSX.Element => {    

    const formApi = useFormApi<EnterNewSubjectTypeForm>();
    const formState = useFormState<EnterNewSubjectTypeForm>();

    const onSubmit = () => {
        formApi.validate();

        const state = formApi.getState()
        if (state.invalid)
            return;

        onNext(state.values.correctedSubjectType);
    }

    return (
        <>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <p className="text-muted">
                            Correcting Subject Type
                    </p>
                        <div className="form-group">
                            <label>Current Subject Type</label>&nbsp;
                            <Dropdown
                                disabled={true}
                                id={`select-subjectType-prevalue`}
                                field="originalSubjectType"
                                className="form-control"
                            >
                                {subjectTypes.map(s => (
                                    <Option key={`SubjectTypePre${s.id}`} value={s.id}>
                                        {s.name}
                                    </Option>
                                ))}
                            </Dropdown>
                        </div>
                        <div className="form-group">
                            <label>Select New Subject Type</label>&nbsp;
                            <Dropdown
                                disabled={false}
                                id={`select-subjectType-correctedValue`}
                                field="correctedSubjectType"
                                className="form-control"
                            >
                                {subjectTypes.map(s => (
                                    <Option key={`SubjectTypeCorr${s.id}`} value={s.id}>
                                        {s.name}
                                    </Option>
                                ))}
                            </Dropdown>
                        </div>

                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button disabled={!formState.values.correctedSubjectType || formState.values.correctedSubjectType == originalSubjectType} className="btn btn-primary" type="submit" onClick={() => onSubmit()}>
                    Next
                </button>
            </div>
        </>);
};
